/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/calendar_medium'
export default icon
